if (!customElements.get('pdp-sticky-atc')) {
  customElements.define(
    'pdp-sticky-atc',
    class PdpStickyAtc extends HTMLElement {
      connectedCallback() {
        // Transformed ancestors (scroll-trigger animations) break position: fixed, so live under <body>.
        // A re-rendered section brings a fresh bar, which replaces any stale one.
        if (this.parentElement !== document.body) {
          document.querySelectorAll('body > pdp-sticky-atc').forEach((bar) => bar.remove());
          document.body.appendChild(this);
          return;
        }

        this.button = this.querySelector('[data-sticky-button]');
        this.label = this.querySelector('[data-sticky-label]');
        this.price = this.querySelector('[data-sticky-price]');
        this.watched = this.getTarget()?.closest(this.dataset.watch);
        if (!this.button || !this.watched) return;

        this.hidden = false;
        this.button.addEventListener('click', () => this.getTarget()?.click());

        // Show the bar once the main buy area has scrolled above the viewport
        this.intersection = new IntersectionObserver(([entry]) => {
          const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-visible', passed);
          document.body.classList.toggle('pdp-sticky-atc-active', passed);
        });
        this.intersection.observe(this.watched);

        // Mirror label, price, disabled and loading state from the main button
        this.mutation = new MutationObserver(() => this.sync());
        this.mutation.observe(this.watched, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['disabled', 'class'],
        });
        this.sync();
      }

      disconnectedCallback() {
        this.intersection?.disconnect();
        this.mutation?.disconnect();
        document.body.classList.remove('pdp-sticky-atc-active');
      }

      getTarget() {
        return document.getElementById(this.dataset.target);
      }

      sync() {
        const target = this.getTarget();
        if (!target) return;

        const loading = target.classList.contains('loading');
        this.button.disabled = target.disabled;
        this.button.classList.toggle('loading', loading);
        this.button.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);

        const targetLabel = target.querySelector(':scope > span:not(.pdp-atc__price):not(.loading__spinner)');
        if (targetLabel && this.label) this.label.textContent = targetLabel.textContent.trim();

        const targetPrice = target.querySelector('.pdp-atc__price');
        const priceText = targetPrice?.textContent.replace(/^[\s—-]+/, '').trim();
        if (priceText && this.price) this.price.textContent = priceText;
      }
    }
  );
}
